var map = {
	"./LearnerWellbeing1.jpg": 6228,
	"./LearnerWellbeing2.jpg": 387,
	"./LearnerWellbeing3.jpg": 3926,
	"./LearnerWellbeing4.jpg": 8685,
	"./LearnerWellbeing5.jpg": 7552,
	"./LearnerWellbeing6.jpg": 1167
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3946;